import { put } from 'redux-saga/effects';
import { AMPLITUDE_EVENT, amplitudeActions, AmplitudeEvent } from '../amplitude';

export function createLogSaga<TAction>(
	event: AMPLITUDE_EVENT,
	transformer?: (action: TAction) => Record<string, unknown> | undefined
) {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return function* logSaga(action: TAction) {
		let eventData: AmplitudeEvent<Record<string, unknown> | undefined> = { id: event };

		if (transformer) {
			eventData = {
				data: transformer(action),
				...eventData
			};
		}

		yield put(amplitudeActions.requestAmplitudeEvent(eventData));
	};
}

export function createLogSagaWithFn<TAction>(
	eventFn: (action: TAction) => AmplitudeEvent<Record<string, unknown> | undefined> | undefined
) {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return function* logSaga(action: TAction) {
		const eventData = eventFn(action);

		if (!eventData) {
			return;
		}

		yield put(amplitudeActions.requestAmplitudeEvent(eventData));
	};
}
